/** Kinds that always render at full width (D-30): the half-width toggle is not offered for them. */
const FULL_ONLY_KINDS: ReadonlySet<string> = new Set(['cover_page', 'price_book', 'line_items_table', 'total', 'spacer']);

/** Kinds a template may hold several of (D-27). Every other kind is one block per template. */
const MULTI_INSTANCE_KINDS: ReadonlySet<string> = new Set(['custom', 'custom_text', 'spacer']);

export type WidthPreset = 'full' | 'half';

export const WIDTH_PRESETS: ReadonlyArray<{ value: WidthPreset; label: string }> = [
  { value: 'full', label: 'Full' },
  { value: 'half', label: '½' }
];

export function isFullOnlyKind(kind: string | null | undefined): boolean {
  return typeof kind === 'string' && FULL_ONLY_KINDS.has(kind);
}

export function isOnePerTemplateKind(kind: string | null | undefined): boolean {
  return typeof kind === 'string' && kind.length > 0 && !MULTI_INSTANCE_KINDS.has(kind);
}

/** The width presets a row offers for a kind: a full-only kind gets Full alone. */
export function widthPresetsForKind(kind: string | null | undefined): ReadonlyArray<{ value: WidthPreset; label: string }> {
  return isFullOnlyKind(kind) ? WIDTH_PRESETS.filter((preset) => preset.value === 'full') : WIDTH_PRESETS;
}
